/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftBookInput } from "../../entities/models/ShiftBookInput";
import { z } from "zod/v4";

export const modelsShiftBookInputSchema = z.object({
    "end_time": z.string(),
"start_time": z.string(),
"station_id": z.int()
    }) as unknown as z.ZodType<ModelsShiftBookInput>